module.exports = __webpack_public_path__ + "img/husky.4578863f.jpg";